export function Comparison() {
    const rows = [
        { label: "Commission", them: "20 à 30% par commande", us: "0%" },
        { label: "Coût annuel*", them: "~5 400€/an minimum", us: "180€/an" },
        { label: "Données clients", them: "Appartiennent à la plateforme", us: "Les vôtres, à 100%" },
        { label: "Image de marque", them: "Noyée parmi la concurrence", us: "100% personnalisée" },
        { label: "Fidélisation", them: "Impossible", us: "Carte de fidélité intégrée" },
        { label: "Marketing", them: "Payant (boost, sponsoring)", us: "Emailing inclus" },
    ];

    return (
        <section className="py-12 px-6 bg-slate-50" id="comparaison">
            <div className="text-center mb-12">
                <h2 className="text-[clamp(1.75rem,4vw,2.75rem)] font-extrabold text-slate-900 leading-[1.2] tracking-tight mb-4">
                    Et si vous êtes sur une plateforme de livraison ?
                </h2>
                <p className="text-[clamp(1.05rem,2vw,1.25rem)] text-slate-500 max-w-[680px] mx-auto leading-relaxed">
                    Uber Eats, Deliveroo, Just Eat… prennent <strong className="text-red-500">20 à 30% de commission</strong> sur chaque commande. Voici la comparaison.
                </p>
            </div>
            <div className="max-w-[700px] mx-auto overflow-x-auto">
                <table className="w-full border-collapse rounded-xl overflow-hidden shadow-md text-[0.9rem]">
                    <thead>
                        <tr>
                            <th className="py-3.5 px-5 text-left bg-slate-800 text-white font-bold text-[0.92rem]" />
                            <th className="py-3.5 px-5 text-left bg-slate-900 text-white font-bold text-[0.92rem]">Plateformes de livraison</th>
                            <th className="py-3.5 px-5 text-left bg-emerald-500 text-white font-bold text-[0.92rem]">Notre solution</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((r, i) => (
                            <tr key={r.label} className={`border-b border-slate-200 last:border-b-0 ${i % 2 === 1 ? "bg-slate-50" : ""}`}>
                                <td className="py-3.5 px-5 font-semibold text-slate-900">{r.label}</td>
                                <td className="py-3.5 px-5 text-red-500">{r.them}</td>
                                <td className="py-3.5 px-5 text-emerald-500 font-bold bg-emerald-50">{r.us}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <p className="text-center text-[0.78rem] text-slate-400 mt-3">
                    *Basé sur 10 commandes/jour, panier moyen 12€, 25% de commission moyenne
                </p>
            </div>
        </section>
    );
}
